// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.teamRoster {
  display: flex;
  flex-direction: column;
  gap: 16px;
  color: #334155;
  font-family: var(--font-body, 'Public Sans', system-ui, sans-serif);
}
.teamRoster__sports {
  padding: 14px;
  border: 1px solid #dce6ee;
  border-radius: 12px;
  background: #f8fbfd;
}
.teamRoster__sports > div {
  display: flex;
  flex-direction: column;
  gap: 2px;
  margin-bottom: 11px;
}
.teamRoster__sports > div strong {
  color: #142033;
  font-size: 13px;
}
.teamRoster__sports > div span {
  color: #69778a;
  font-size: 11.5px;
  line-height: 1.45;
}
.teamRoster__sports ul {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
  padding: 0;
  margin: 0;
  list-style: none;
}
.teamRoster__sports li {
  display: inline-flex;
  align-items: center;
  gap: 7px;
  padding: 6px 9px;
  border: 1px solid #d7e0e8;
  border-radius: 999px;
  background: #fff;
}
.teamRoster__sports li > span {
  color: #263e56;
  font-size: 11.5px;
  font-weight: 750;
}
.teamRoster__sports li b {
  color: #9a6517;
  font-size: 10px;
  font-weight: 800;
}
.teamRoster__sports li.is-complete b {
  color: #267a47;
}
.teamRoster__participants {
  overflow: hidden;
  border: 1px solid #e1e8ef;
  border-radius: 12px;
  background: #fff;
}
.teamRoster__participants > header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 11px 14px;
  border-bottom: 1px solid #e8edf2;
  background: #f8fafc;
}
.teamRoster__participants > header strong {
  color: #263e56;
  font-size: 12px;
  text-transform: uppercase;
  letter-spacing: 0.045em;
}
.teamRoster__participants > header span {
  min-width: 24px;
  padding: 3px 7px;
  border-radius: 999px;
  background: #eaf4fb;
  color: #155d8c;
  font-size: 11px;
  font-weight: 800;
  text-align: center;
}
.teamRoster__row {
  display: flex;
  min-width: 0;
  align-items: center;
  gap: 10px;
  padding: 9px 14px;
  border-bottom: 1px solid #eef2f5;
}
.teamRoster__row:last-child {
  border-bottom: 0;
}
.teamRoster__row > strong {
  overflow: hidden;
  color: #142033;
  font-size: 13.5px;
  font-weight: 650;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.teamRoster__avatar {
  display: flex;
  width: 34px;
  height: 34px;
  flex: 0 0 34px;
  align-items: center;
  justify-content: center;
  overflow: hidden;
  border-radius: 50%;
  background: #eaf4fb;
  color: #155d8c;
  font-size: 11px;
  font-weight: 800;
}
.teamRoster__avatar img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}
.teamRoster__empty {
  padding: 30px;
  color: #69778a;
  text-align: center;
}
@media (max-width: 600px) {
  .teamRoster__sports li {
    width: 100%;
    justify-content: space-between;
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/SchoolTeamPLayersSummary/SchoolTeamPlayersSummary.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,cAAc;EACd,mEAAmE;AACrE;AACA;EACE,aAAa;EACb,yBAAyB;EACzB,mBAAmB;EACnB,mBAAmB;AACrB;AACA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,mBAAmB;AACrB;AACA;EACE,cAAc;EACd,eAAe;AACjB;AACA;EACE,cAAc;EACd,iBAAiB;EACjB,iBAAiB;AACnB;AACA;EACE,aAAa;EACb,eAAe;EACf,QAAQ;EACR,UAAU;EACV,SAAS;EACT,gBAAgB;AAClB;AACA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,gBAAgB;EAChB,yBAAyB;EACzB,oBAAoB;EACpB,gBAAgB;AAClB;AACA;EACE,cAAc;EACd,iBAAiB;EACjB,gBAAgB;AAClB;AACA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;AAClB;AACA;EACE,cAAc;AAChB;AACA;EACE,gBAAgB;EAChB,yBAAyB;EACzB,mBAAmB;EACnB,gBAAgB;AAClB;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,kBAAkB;EAClB,gCAAgC;EAChC,mBAAmB;AACrB;AACA;EACE,cAAc;EACd,eAAe;EACf,yBAAyB;EACzB,uBAAuB;AACzB;AACA;EACE,eAAe;EACf,gBAAgB;EAChB,oBAAoB;EACpB,mBAAmB;EACnB,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,kBAAkB;AACpB;AACA;EACE,aAAa;EACb,YAAY;EACZ,mBAAmB;EACnB,SAAS;EACT,iBAAiB;EACjB,gCAAgC;AAClC;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;EAChB,cAAc;EACd,iBAAiB;EACjB,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;AACrB;AACA;EACE,aAAa;EACb,WAAW;EACX,YAAY;EACZ,cAAc;EACd,mBAAmB;EACnB,uBAAuB;EACvB,gBAAgB;EAChB,kBAAkB;EAClB,mBAAmB;EACnB,cAAc;EACd,eAAe;EACf,gBAAgB;AAClB;AACA;EACE,WAAW;EACX,YAAY;EACZ,iBAAiB;AACnB;AACA;EACE,aAAa;EACb,cAAc;EACd,kBAAkB;AACpB;AACA;EACE;IACE,WAAW;IACX,8BAA8B;EAChC;AACF","sourcesContent":[".teamRoster {\n  display: flex;\n  flex-direction: column;\n  gap: 16px;\n  color: #334155;\n  font-family: var(--font-body, 'Public Sans', system-ui, sans-serif);\n}\n.teamRoster__sports {\n  padding: 14px;\n  border: 1px solid #dce6ee;\n  border-radius: 12px;\n  background: #f8fbfd;\n}\n.teamRoster__sports > div {\n  display: flex;\n  flex-direction: column;\n  gap: 2px;\n  margin-bottom: 11px;\n}\n.teamRoster__sports > div strong {\n  color: #142033;\n  font-size: 13px;\n}\n.teamRoster__sports > div span {\n  color: #69778a;\n  font-size: 11.5px;\n  line-height: 1.45;\n}\n.teamRoster__sports ul {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 8px;\n  padding: 0;\n  margin: 0;\n  list-style: none;\n}\n.teamRoster__sports li {\n  display: inline-flex;\n  align-items: center;\n  gap: 7px;\n  padding: 6px 9px;\n  border: 1px solid #d7e0e8;\n  border-radius: 999px;\n  background: #fff;\n}\n.teamRoster__sports li > span {\n  color: #263e56;\n  font-size: 11.5px;\n  font-weight: 750;\n}\n.teamRoster__sports li b {\n  color: #9a6517;\n  font-size: 10px;\n  font-weight: 800;\n}\n.teamRoster__sports li.is-complete b {\n  color: #267a47;\n}\n.teamRoster__participants {\n  overflow: hidden;\n  border: 1px solid #e1e8ef;\n  border-radius: 12px;\n  background: #fff;\n}\n.teamRoster__participants > header {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  padding: 11px 14px;\n  border-bottom: 1px solid #e8edf2;\n  background: #f8fafc;\n}\n.teamRoster__participants > header strong {\n  color: #263e56;\n  font-size: 12px;\n  text-transform: uppercase;\n  letter-spacing: 0.045em;\n}\n.teamRoster__participants > header span {\n  min-width: 24px;\n  padding: 3px 7px;\n  border-radius: 999px;\n  background: #eaf4fb;\n  color: #155d8c;\n  font-size: 11px;\n  font-weight: 800;\n  text-align: center;\n}\n.teamRoster__row {\n  display: flex;\n  min-width: 0;\n  align-items: center;\n  gap: 10px;\n  padding: 9px 14px;\n  border-bottom: 1px solid #eef2f5;\n}\n.teamRoster__row:last-child {\n  border-bottom: 0;\n}\n.teamRoster__row > strong {\n  overflow: hidden;\n  color: #142033;\n  font-size: 13.5px;\n  font-weight: 650;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n.teamRoster__avatar {\n  display: flex;\n  width: 34px;\n  height: 34px;\n  flex: 0 0 34px;\n  align-items: center;\n  justify-content: center;\n  overflow: hidden;\n  border-radius: 50%;\n  background: #eaf4fb;\n  color: #155d8c;\n  font-size: 11px;\n  font-weight: 800;\n}\n.teamRoster__avatar img {\n  width: 100%;\n  height: 100%;\n  object-fit: cover;\n}\n.teamRoster__empty {\n  padding: 30px;\n  color: #69778a;\n  text-align: center;\n}\n@media (max-width: 600px) {\n  .teamRoster__sports li {\n    width: 100%;\n    justify-content: space-between;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
